import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Step from '../shared/Step';
import UpsellItem from './UpsellItem';
import { addProductToCart, removeProductFromCart } from '../../reducers/cart';
import { selectUpsellOption, deselectUpsellOption } from '../../reducers/form';
import API from '../../utils/api';
import { getCampsIntervals, joinDates } from '../../utils/helpers';
import GTMService from '../../utils/gtm';

const gtm = new GTMService();
const api = new API();

const Upsells = ({
  title,
  sport,
  gender,
  selectedUpsellOptions,
  selectedCampOptions,
  selectUpsellOption,
  deselectUpsellOption,
  addProductToCart,
  removeProductFromCart,
}) => {
  const [upsells, setUpsells] = useState([]);

  useEffect(() => {
    let skip = false;

    const intervals = getCampsIntervals(Object.values(selectedCampOptions));
    Promise.all(
      intervals.map((interval) =>
        api.fetchUpsell({
          gender,
          sport,
          start_date: interval.start,
          end_date: interval.end,
        })
      )
    ).then((res) => {
      if (!skip) {
        setUpsells(joinDates([].concat(...res.map((r) => r.results))));
      }
    });

    return () => (skip = true);
  }, [gender, sport, selectedCampOptions]);

  if (upsells.length === 0) {
    return null;
  }

  const handleAdd = async (item, dateId) => {
    const product = item.dates.find((d) => String(d.id) === dateId);

    const res = await addProductToCart({
      type: 'gear-upsell',
      product,
    });

    if (res) {
      selectUpsellOption(product.id, {
        participantProductId: res.participant_product_id,
        name: item.display_name,
        product,
      });
      gtm.trackAddToCart(item, 'gear-upsell');
    }
  };

  const handleRemove = async (id) => {
    await removeProductFromCart(selectedUpsellOptions[id].participantProductId);
    deselectUpsellOption(id);
  };

  console.log('upsells check', upsells);

  return (
    <Step title="+">
      <Step.Sub title={title}>
        <div className="extras">
          <div className="extras__list">
            {upsells.map((item, index) => {
              const dateId = Object.keys(selectedUpsellOptions).find(
                (key) => !!item.dates.find((d) => d.id === Number(key))
              );
              return (
                <UpsellItem
                  key={`${item.name}-${index}`}
                  item={item}
                  isSelected={!!dateId}
                  onAdd={(dateId) => handleAdd(item, dateId)}
                  onRemove={() => handleRemove(dateId)}
                />
              );
            })}
          </div>
        </div>
      </Step.Sub>
    </Step>
  );
};

const mapStateToProps = (state) => ({
  gender: state.form.camper.gender,
  intervals: getCampsIntervals(Object.values(state.form.selectedCampOptions)),
  selectedUpsellOptions: state.form.selectedUpsellOptions,
  selectedCampOptions: state.form.selectedCampOptions,
});

const mapDispatchToProps = (dispatch) => ({
  addProductToCart: (product) => dispatch(addProductToCart(product)),
  removeProductFromCart: (id) => dispatch(removeProductFromCart(id)),
  selectUpsellOption: (key, value) => dispatch(selectUpsellOption(key, value)),
  deselectUpsellOption: (key) => dispatch(deselectUpsellOption(key)),
});

Upsells.propTypes = {
  title: PropTypes.string.isRequired,
  sport: PropTypes.string.isRequired,
  gender: PropTypes.string,
  selectedUpsellOptions: PropTypes.object.isRequired,
  selectedCampOptions: PropTypes.object.isRequired,
  addProductToCart: PropTypes.func.isRequired,
  removeProductFromCart: PropTypes.func.isRequired,
  selectUpsellOption: PropTypes.func.isRequired,
  deselectUpsellOption: PropTypes.func.isRequired,
};

Upsells.displayName = 'Upsells';

export default connect(mapStateToProps, mapDispatchToProps)(Upsells);
